export default __webpack_public_path__ + "static/media/nsc-img2.6abd865d.png";